import { useSecurityDialog } from "../SecurityDialogProvider"
import {
  SecurityDialog,
  SecurityDialogContainer,
  SecurityDialogTitle,
  SecurityLabel,
  SecurityPrimaryButton,
  WrongAccount,
} from "../common"
import { useSendEmail } from "../common/useSendEmail"

export type AccessCodeForgottenDialogProps = {
  open: boolean
  goHome: () => void
}

export const AccessCodeForgottenDialog = ({
  open,
  goHome,
}: AccessCodeForgottenDialogProps) => {
  const securityDialog = useSecurityDialog()
  const { sendEmail, loading } = useSendEmail()
  const handleActivatePrivateAccess = () => {
    sendEmail().then(() => securityDialog.emailSentDialog({ goHome }))
  }
  return (
    <SecurityDialog open={open}>
      <SecurityDialogTitle />
      <SecurityDialogContainer>
        <SecurityLabel>Vous avez oublié votre code d'accès.</SecurityLabel>
        <SecurityLabel>
          Cliquez sur le lien ci-dessous et suivez la procédure de réinitialisation.
        </SecurityLabel>
        <SecurityPrimaryButton
          onClick={handleActivatePrivateAccess}
          disabled={loading}
        >
          Réinitialiser
        </SecurityPrimaryButton>
      </SecurityDialogContainer>
      <WrongAccount onClickGoHome={goHome} />
    </SecurityDialog>
  )
}
